import { useState, useContext } from "react";
import ExperienceContext from "./ExperienceContext";
import { Group, Button, TextInput, Modal } from "@mantine/core";
import { showErrorNotification } from "../../utils/Notifications";
function EmbedLinkModal({
	isEmbedLinkSpotOpen,
	setIsEmbedLinkSpotOpen,
	activePanoId,
}) {
	const { addNewLinkspot } = useContext(ExperienceContext);
	const [embedLink, setEmbedLink] = useState("");
	const handleCreate = () => {
		if (embedLink === "") {
			showErrorNotification("Link cannot be empty");
			return;
		}
		addNewLinkspot(activePanoId, embedLink);
		setEmbedLink("");
		setIsEmbedLinkSpotOpen(false);
	};
	return (
		<Modal
			centered
			size="lg"
			opened={isEmbedLinkSpotOpen}
			onClose={() => {
				setIsEmbedLinkSpotOpen(false);
				setEmbedLink("");
			}}
			title="Add Link Spot"
			styles={{
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
				body: { height: "80%" },
			}}
		>
			<TextInput
				data-autofocus
				placeholder="Enter link here"
				required
				styles={{
					input: {
						backgroundColor: "#040F1F",
						border: "1px solid #09254E",
					},
				}}
				value={embedLink}
				onChange={(e) => setEmbedLink(e.target.value)}
			/>
			<Group style={{ width: "100%", justifyContent: "end" }}>
				<Button
					variant="outline"
					my={10}
					px={30}
					size="xs"
					radius={"md"}
					sx={(theme) => ({
						color: theme.colors.white[0],
						borderColor: theme.colors.ivisit_light[0],
					})}
					onClick={() => {
						setEmbedLink("");
						setIsEmbedLinkSpotOpen(false);
					}}
				>
					Cancel
				</Button>
				<Button
					variant="outline"
					my={10}
					px={30}
					size="xs"
					radius={"md"}
					sx={(theme) => ({
						color: theme.colors.white[0],
						borderColor: theme.colors.ivisit_light[0],
					})}
					onClick={handleCreate}
				>
					Create
				</Button>
			</Group>
		</Modal>
	);
}

export default EmbedLinkModal;
